export default "__VITE_ASSET__B0WQ_R1D__"